import React from 'react';
import Toggle from 'components/toggle';
import Colors from 'styles/colors';
import { useAuthUser } from 'hooks/useAuthUser';
import { FAL } from 'icons/fa';
import * as Style from './style';

/**
 * Pointing Continuum at the stage API is a debugging aid, so the switch is only
 * rendered for the ePublishing admin account.
 */
const STAGE_API_ADMIN_EMAIL = 'admin@epublishing.com';

/**
 * The same flag `window.continuum.api.staging.enable()` writes (see App.js) and
 * that `environmentOptions()` reads to pick the API domain (see utils/helpers).
 */
export const STAGE_API_STORAGE_KEY = 'api.staging.enabled';

const StageApiToggle = () => {
  const { email } = useAuthUser();
  const isStageApiEnabled = localStorage.getItem(STAGE_API_STORAGE_KEY) === 'true';

  if (email !== STAGE_API_ADMIN_EMAIL) return null;

  /**
   * The API URI is read once, when the Apollo client is built at boot, so the
   * switch has to reload for requests to reach the other host.
   */
  function toggleStageApi() {
    localStorage.setItem(STAGE_API_STORAGE_KEY, isStageApiEnabled ? 'false' : 'true');
    window.location.reload();
  }

  return (
    <Style.StageApiItem>
      <Style.StageApiRow active={isStageApiEnabled}>
        <Style.LinkInner id="stage-api"><FAL icon="exchange" />Stage API</Style.LinkInner>
        <Toggle
          initial={isStageApiEnabled}
          onToggle={toggleStageApi}
          width={46}
          height={26}
          thumbWidth={16}
          thumbHeight={16}
          padding={5}
          wrapperPadding={0}
          wrapperPaddingTop={0}
          wrapperPaddingBottom={0}
          bgClear={Colors.pickledBlueWood}
        />
      </Style.StageApiRow>
    </Style.StageApiItem>
  );
};

export default StageApiToggle;
